import { HTTP } from '@/http';

export default class SupportService {

  createTicket(message) {
    return HTTP.post(`support/tickets`, message);
  }

}





// WEBPACK FOOTER //
// ./src/services/SupportService.js